<template>
  <div class="loader">
    <span />
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style scoped lang="scss">
@use 'mixins' as *;
@use 'variables';

.loader {
  height: 100px;
  width: 100px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 25;

  @include breakpoint-md {
    left: 60%;
  }

  span {
    display: block;
    position: absolute;
    margin: auto;
    height: 100%;
    width: 100%;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: 100%;
      width: 100%;
      border: 2px solid variables.$color-brand;
      border-radius: 50%;
      opacity: 0;
      animation: loader-scaled 1.5s cubic-bezier(0.075, 0.82, 0.165, 1) infinite;
    }

    &::after {
      animation: loader 1.5s cubic-bezier(0.075, 0.82, 0.165, 1) 0.25s infinite;
    }
  }
}

.careers--component .loader {
  position: absolute;
  left: 50%;
}

@keyframes loader-scaled {
  0%   { transform: translate3d(0, 0, 0) scale(0); opacity: 1; }
  100% { transform: translate3d(0, 0, 0) scale(1.5); opacity: 0; }
}

@keyframes loader {
  0%   { transform: translate3d(0, 0, 0) scale(0); opacity: 1; }
  100% { transform: translate3d(0, 0, 0) scale(1); opacity: 0; }
}
</style>
